import { Image as SemanticUIImage } from 'semantic-ui-react';
import styled from 'styled-components';

const Image = styled(SemanticUIImage).attrs(() => ({
  size: 'tiny'
}))``;

export default Image;
